import { FlowPage } from '@monthio/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { userConsentManager } from '../../userConsentManager'
import { AccessibleLandingPageContent } from './Components/AccessibleLandingPageContent'
import { useLandingPageModule } from './useLandingPageModule'

export const LandingPage = () => {
	const { t } = useTranslation()
	const {
		data: { flowSteps },
		config: { clientName, logo },
		finish,
	} = useLandingPageModule()

	const handleClick = useCallback(() => {
		userConsentManager.setConsent('flow')
		finish(undefined)
	}, [finish])

	return (
		<FlowPage>
			<FlowPage.Content $spacing="xl">
				<AccessibleLandingPageContent
					logoSrc={logo}
					clientName={clientName}
					flowSteps={flowSteps}
				/>
			</FlowPage.Content>
			<FlowPage.Footer
				actions={
					<FlowPage.Cta onClick={handleClick}>{t('btn-start')}</FlowPage.Cta>
				}
			/>
		</FlowPage>
	)
}
